

































































import { defineComponent, ref, watch } from '@vue/composition-api';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import TrForm from '@front-app/components/form/Form.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormError from '@front-app/components/form/FormError.vue';
import PublicAuthPage from '@front-app/components/layouts/PublicAuthPage.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import { resendActivationCode } from '@front-app/services/UserApi/UserApi';
import { v } from '@front-app/components/form/validation/useValidation';
import { required } from '@front-app/components/form/validation/validators';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import ContactUsLink from '@front-app/components/ContactUsLink.vue';

export default defineComponent({
	components: {
		CtaButton,
		TrForm,
		FormSection,
		FormInput,
		FormLabel,
		FormError,
		PublicAuthPage,
		SuccessCard,
		ErrorCard,
		ColumnContainer,
		PaddedContent,
		ContactUsLink,
	},
	props: {
		email: {
			type: String,
			required: false,
			default: '',
		},
	},
	setup(props) {
		const emailVal = ref(props.email);
		watch(() => props.email, () => {
			emailVal.value = props.email;
		}, { immediate: true });

		const validation = v({
			email: {
				value: emailVal,
				rules: [required()],
			},
		});

		const {
			track,
			clear,
			isLoading,
			isSuccess,
			isError,
		} = useAsyncStatus();
		const {
			focusFirstInvalid,
		} = useFocusFirstInvalidField({ containerSelector: '.resend-activation-form' });
		const submit = () => {
			clear(0);
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}
			track(resendActivationCode(emailVal.value));
		};

		return {
			validation,
			submit,
			isLoading,
			isSuccess,
			isError,
			emailVal,
			// Util
			ButtonPalettes,
			Size,
		};
	},
});
